import { LargeShareholderSearchFilter } from '../../models/largeShareholderSearchFilter';

export interface ILargeShareholderListState {
  searchFilter: LargeShareholderSearchFilter;
  currentPage: number;
  pageSize: number;
  sortBy: string;
  ascending: boolean;
}

export const initialLargeShareholderListState: ILargeShareholderListState = {
  searchFilter: {},
  currentPage: 1,
  pageSize: 10,
  sortBy: 'name',
  ascending: true
};
